var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.container, on: { mouseleave: _vm.deselectTab } },
    [
      _c(
        "NsTabs",
        {
          class: _vm.$style.tabs,
          attrs: {
            selected: _vm.navSelected,
            height: 38,
            "slider-width-to-content": "",
            "use-hover": ""
          },
          on: { select: _vm.selectTab }
        },
        _vm._l(_vm.navigation, function(item) {
          return _c("NsTab", { key: item.name, class: _vm.$style.tab }, [
            _c("span", [_vm._v(_vm._s(item.name))]),
            _vm._v(" "),
            _vm.useTopLevelNav
              ? _c("a", {
                  class: _vm.$style.tabLink,
                  attrs: { href: item.href }
                })
              : _vm._e()
          ])
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "nav",
        { class: _vm.$style.tabsDropdown },
        [
          _c(
            "NsTabsItems",
            { attrs: { selected: _vm.navSelected } },
            _vm._l(_vm.navigation, function(item, index) {
              return _c(
                "div",
                { key: index, class: _vm.$style.tabItem },
                [
                  item.navContentUrl
                    ? _c("NsTopnavSection", {
                        attrs: {
                          "custom-components-url": item.navContentUrl,
                          "nav-type": item.navContentType,
                          image: {
                            src: item.topNavImageOverlayUrl,
                            alt: item.topNavImageOverlayAltText,
                            overlayText: item.topNavImageOverlayText
                          },
                          navigation: JSON.stringify(item.subnav),
                          opened: _vm.navSelected === index,
                          "hide-see-all": item.hideSeeAll
                        }
                      })
                    : _c("NsTopnavSection", {
                        attrs: {
                          "nav-type": item.type || "legacy",
                          navigation: JSON.stringify(item.subnav),
                          opened: _vm.navSelected === index,
                          "hide-see-all": item.hideSeeAll
                        }
                      })
                ],
                1
              )
            }),
            0
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }